import { PortalHost } from "@gorhom/portal";
import React, { FC, JSX } from "react";
import { StatusBar } from "react-native";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { Notifications } from "@lookiero/sty-psp-notifications";
import { theme } from "@lookiero/sty-psp-ui";
import { MESSAGING_CONTEXT_ID } from "../../delivery/baseBootstrap";
import { DOMAIN } from "../i18n/i18n";

interface AppProps {
  readonly children: JSX.Element;
}

const App: FC<AppProps> = ({ children }) => {
  const { colorBgBase } = theme();

  return (
    <SafeAreaProvider>
      <StatusBar backgroundColor={colorBgBase} barStyle="dark-content" translucent />
      <Notifications contextId={MESSAGING_CONTEXT_ID} domain={DOMAIN} portalHostName="Checkout" />
      <PortalHost name="Checkout" />
      {children}
    </SafeAreaProvider>
  );
};

export { App };
